@if (regioverantwoordelijkenPage) {
  <mat-nav-list>
    <h3 class="subheader">
      Regioverantwoordelijken
      @if (!regioverantwoordelijkenPage.isEmpty()) {
        <zah-sort-button
          [sortOrder]="initialPageRequest.getSortOrder()"
          (sortOrderChange)="onSortOrderChange($event)">
        </zah-sort-button>
      }
    </h3>
    @for (regioverantwoordelijke of regioverantwoordelijkenPage.getItems(); track regioverantwoordelijke) {
      <mat-list-item (click)="onRegioverantwoordelijkeClick(regioverantwoordelijke)">
        <zah-avatar matListItemAvatar [name]="regioverantwoordelijke.getNaam()"></zah-avatar>
        <div matListItemTitle>{{regioverantwoordelijke.getNaam()}} <span class="mat-small">({{regioverantwoordelijke.getPersoneelsnummer()}})</span></div>
        <div matListItemLine class="mat-small">{{regioverantwoordelijke.getEmail()}}</div>
        <button matListItemMeta
          disableRipple="true"
          class="center-vertically"
          mat-icon-button
          (click)="$event.stopPropagation(); onDeleteClick(regioverantwoordelijke)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </mat-list-item>
      <mat-divider></mat-divider>
    }
    @if (regioverantwoordelijkenPage.isEmpty()) {
      <mat-list-item
        class="no-list-item-highlight"
        disableRipple>
        <div matListItemTitle>Geen regioverantwoordelijken gevonden</div>
      </mat-list-item>
    }
    <mat-list-item class="no-list-item-highlight overflow-visible-for-button-shading"
      disableRipple
      lines="2">
      <span matListItemMeta class="center-vertically">
        <button mat-mini-fab
          color="accent"
          (click)="onAddClick()">
          <mat-icon>add</mat-icon>
        </button>
      </span>
    </mat-list-item>
  </mat-nav-list>
  @if (!regioverantwoordelijkenPage.isEmpty()) {
    <zah-paginator
      [currentPage]="regioverantwoordelijkenPage"
      [pageSize]="initialPageRequest.getPageSize()"
      (pageSizeChange)="onPageSizeChange($event)"
      (pageChange)="onPageChange($event)">
    </zah-paginator>
  }
}
